<nb-card>
  <div *ngFor="let import of failedImports">
    <h6>Product:</h6>
    <span>{{import.product | json}}</span>
    <br/>
    <h6>Error:</h6>
    <span>{{import.error?.error?.message | json}}</span>
  </div>
</nb-card>